import request from "root/js/request";

export const getAnalyticsCrossMPProductCostsOzon = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/income_product_cost_products/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const updateAnalyticsCrossMPProductCostsIncomeOzon = async ({
  cabinet_id,
  marketplace,
  data,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/income_product_cost_products/bulk_update/",
    method: "post",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
    data: data,
  });
  return response.data;
};
